export default class SideMenu {
  constructor() {
    this.element = document.querySelector('.js-side-menu')
    this.trigger = document.querySelector('.js-side-menu-trigger')
    this.bodyClass = 'has--side-menu-open'

    if (!this.element || !this.trigger) {
      return
    }

    this.init()
  }

  init() {
    const body = document.getElementsByTagName('body')[0]
    this.trigger.addEventListener('click', () => {
      if (body.classList.contains(this.bodyClass)) {
        body.classList.remove(this.bodyClass)
      } else {
        body.classList.add(this.bodyClass)
      }
    })
  }
}
